import get from "lodash/get";
import isEqual from "lodash/isEqual";

export function useSelectValue() {
  /**
   * Finds the matched item from the list of items based on the model value.
   *
   * @param modelValue - The value to match against the items.
   * @param items - The list of items to search through.
   * @param key - The key to use for retrieving the value from the item.
   * @param returnObject - Whether the model value is an object and should be compared as such.
   * @returns The matched item if found, otherwise undefined.
   */
  function getMatchedItem(
    modelValue: unknown,
    items: unknown[],
    key: string | undefined | null,
    returnObject: boolean = false
  ): unknown {
    const matchedItem = (items as []).find((item) => {
      // 選択肢項目から比較用value取得の優先順
      // 1. item-value属性
      // 2. value属性
      // 3. item自体
      const originItemValue = get(item, (key ?? "value") as string) ?? item;
      let targetItemValue = modelValue;
      if (returnObject) {
        // return-object属性が指定する場合、modelValueはitem自体なので、下記の優先順で比較用valueを取得
        // 1. item-value属性
        // 2. value属性
        // 3. item自体
        targetItemValue =
          get(modelValue, (key ?? "value") as string) ?? modelValue;
      }
      return isEqual(originItemValue, targetItemValue);
    });
    return matchedItem;
  }
  return { getMatchedItem };
}
